import CircleIcon from '@mui/icons-material/Circle'
import SquareIcon from '@mui/icons-material/Square'
import { Box, Stack } from '@mui/material'

import { FC } from 'react'

import { Difficulties } from '../../models/Difficulties.model'

const DifficultyColors: Record<Difficulties, string> = {
  [Difficulties.White]: '#ffffff',
  [Difficulties.Green]: '#69804c',
  [Difficulties.Blue]: '#1591cd',
  [Difficulties.Black]: '#000000',
  [Difficulties.DoubleBlack]: '#000000',
}

type DifficultyIconProps = {
  difficultyId: Difficulties
  fontSize?: number
}

export const DifficultyIcon: FC<DifficultyIconProps> = (props) => {
  return (
    <Box fontSize={props.fontSize ?? 18}>
      {props.difficultyId === Difficulties.White && (
        <CircleIcon fontSize="inherit" sx={{ color: DifficultyColors[props.difficultyId] }} />
      )}
      {props.difficultyId === Difficulties.Green && (
        <CircleIcon fontSize="inherit" sx={{ color: DifficultyColors[props.difficultyId] }} />
      )}
      {props.difficultyId === Difficulties.Blue && (
        <SquareIcon fontSize="inherit" sx={{ color: DifficultyColors[props.difficultyId] }} />
      )}
      {props.difficultyId === Difficulties.Black && (
        <SquareIcon
          fontSize="inherit"
          sx={{ color: DifficultyColors[props.difficultyId], transform: 'rotate(45deg)' }}
        />
      )}
      {props.difficultyId === Difficulties.DoubleBlack && (
        <Stack marginTop="-0.25em" marginBottom="-0.25em">
          <SquareIcon
            fontSize="inherit"
            sx={{
              color: DifficultyColors[props.difficultyId],
              mb: '-0.5em',
              transform: 'rotate(45deg) scale(0.75)',
            }}
          />
          <SquareIcon
            fontSize="inherit"
            sx={{ color: DifficultyColors[props.difficultyId], transform: 'rotate(45deg) scale(0.75)' }}
          />
        </Stack>
      )}
    </Box>
  )
}
DifficultyIcon.displayName = 'DifficultyIcon'
